import React, { Fragment, useState } from "react";
import parser from "html-react-parser";

const CheckboxField = ({
  label,
  name,
  items,
  required,
  onChangeHandler,
  isValid = true,
  errorMessage,
  description,
  explanation,
  value,
  disableErrorMessage = false,
  disableRequireAsterisk = false,
}) => {
  const [isChecked, setIsChecked] = useState(false);
  return (
    <>
      <div className="tps-form-question">
        <div className="tps-form-label">
          <span
            className={`EditingFormLabel ${
              required && !disableRequireAsterisk && "tps-field-required"
            } `}
          >
            {label && parser(label)}
          </span>
          {!!explanation && explanation !== "" && (
            <div className="fas fa-info-circle tps-form-tip has-tip">
              <div
                className="tooltiptext"
                dangerouslySetInnerHTML={{ __html: explanation }}
              ></div>
            </div>
          )}
        </div>
        <div className="tps-form-input">
          <div className="EditingFormControlNestedControl editing-form-control-nested-control">
            <span className="checkbox checkbox-list-vertical">
              {items &&
                items?.map((item, index) => {
                  return (
                    <Fragment key={index}>
                      {index > 0 && <br />}
                      <input
                        type="checkbox"
                        id={`${name}${index}`}
                        name={name}
                        value={item.value}
                        className="tps-to-validate"
                        onChange={(event) => onChangeHandler(event)}
                        {...(value.find((v) => v === item.value) !== undefined
                          ? { checked: true }
                          : {})}
                      />
                      <label
                        htmlFor={`${name}${index}`}
                        dangerouslySetInnerHTML={{
                          __html: item.label || item.value,
                        }}
                      ></label>
                    </Fragment>
                  );
                })}
              {!isValid && required && !disableErrorMessage && (
                <span className={"EditingFormErrorLabel"}>{errorMessage}</span>
              )}
            </span>
          </div>
          {!!description && description !== "" && (
            <p
              className="tps-form-input-explaination"
              dangerouslySetInnerHTML={{ __html: description }}
            ></p>
          )}
        </div>
      </div>
    </>
  );
};

export default CheckboxField;
